<div fxFlex="100" fxLayoutAlign="center center">
    <button mat-icon-button>
      <mat-icon>add</mat-icon>
    </button>
  </div>
